import { useDispatch, useSelector } from "react-redux";
import { selectStatefulCosts, submitCheckout } from "../../ducks/checkoutSlice";
import { resetSelfcheckoutSession } from "../../ducks/selfcheckoutSession";
import useGoTo from "../../hooks/useGoTo";
import useToast from "../../hooks/useToast";
import useSubmitSelfcheckout from "../../hooks/useSubmitSelfcheckout";
import QuestionCheckout from "../QuestionCheckout";

// POS: o pedido é criado e o pagamento abre no app nativo do POS, que recebe
// o total em reais (o TEF do totem é que recebe em centavos).
export default function SelfCheckoutPOS() {
  const dispatch = useDispatch();
  const goTo = useGoTo();
  const { toastError } = useToast();
  const costs = useSelector(selectStatefulCosts);

  const submit = useSubmitSelfcheckout(async () => {
    if (!window.posNativeInterface) {
      toastError("Interface do meio de pagamento nao existe!");
      return;
    }

    const order = await dispatch(submitCheckout({}));
    window.posNativeInterface.startPosPayment(order.id, costs.total);
    dispatch(resetSelfcheckoutSession());
    goTo("/");
  });

  return <QuestionCheckout dispatchSubmitCheckout={submit} />;
}
